import Udesk from 'Udesk';
import React, { FC, memo } from 'react';
import BaseTemplate from '../components/Template';

interface TemplateProps {}

const Template: FC<TemplateProps> = memo((props) => {
    return (
        <BaseTemplate {...props} inspectDataSource={Udesk.enums.inspectDataSources.voiceCall.id} />
    );
});

export default Template;
